export const fetchBrowserGeolocationPosition =
  async (): Promise<GeolocationPosition> => {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, async (error) => {
        console.warn(`Geolocation getCurrentPosition error`, error)

        if (error.code === GeolocationPositionError.TIMEOUT) {
          console.log(`Geolocation getCurrentPosition timeout; retrying.`)

          try {
            resolve(await fetchBrowserGeolocationPosition())
          } catch (error) {
            reject(error)
          }

          return
        }

        if (error.code === GeolocationPositionError.PERMISSION_DENIED) {
          console.log(`Browser has denied geolocation permissions.`)
          reject(error)
          return
        }

        const status = await navigator.permissions.query({
          name: `geolocation`,
        })

        if (status.state === `denied`) {
          console.log(`Browser has denied geolocation permissions.`)
          reject(error)
        }

        if (status.state === `granted`) {
          try {
            resolve(await fetchBrowserGeolocationPosition())
          } catch (error) {
            reject(error)
          }
        }

        if (status.state === `prompt`) {
          const abortController = new AbortController()

          status.addEventListener(
            `change`,
            async (event) => {
              const { state } = event.target as PermissionStatus

              if (state === `denied`) {
                console.log(`Browser has denied geolocation permissions.`)
                abortController.abort()
                reject(error)
              }

              if (state === `granted`) {
                try {
                  resolve(await fetchBrowserGeolocationPosition())
                } catch (error) {
                  reject(error)
                }
              }
            },
            { signal: abortController.signal }
          )

          console.log(`Prompting for geolocation permission.`)
        }
      })
    })
  }
